import React, { Fragment, useContext } from 'react'
import { Card, Grid, List, ListItem, Message } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import Moment from "react-moment";

const RequestReviewNoteList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { requestReviewNotesById } = rootStore.requestReviewNoteStore;

    return (
        <Fragment>
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {requestReviewNotesById.map(([group, requestReviewNotes]) => (
                    <Fragment key={group}>
                        {requestReviewNotes.map(requestReviewNote => (
                            <Grid.Column width={8}>
                                <Card.Group>
                                    <Card fluid>
                                        <Card.Content>
                                            <Card.Header>
                                                {requestReviewNote.noteType}
                                            </Card.Header>
                                            <Card.Meta>
                                                <List>
                                                    <ListItem>ID: {requestReviewNote.id}</ListItem>
                                                    <ListItem>Submitted By: {requestReviewNote.createdByName}</ListItem>
                                                    <ListItem>Submitted On: <Moment format={'MMM D YYYY hh:mm:ss A'} date={requestReviewNote.dateCreated} /></ListItem>
                                                </List>
                                            </Card.Meta>
                                            <Card.Description>
                                                <Message content={requestReviewNote.note} />
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                            </Grid.Column>
                        ))}
                    </Fragment>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(RequestReviewNoteList);